export const HOME_FEATURED_PRODUCT_REQUEST = "HOME_FEATURED_PRODUCT_REQUEST"
export const HOME_FEATURED_PRODUCT_SUCCESS = "HOME_FEATURED_PRODUCT_SUCCESS"
export const HOME_FEATURED_PRODUCT_FAIL = "HOME_FEATURED_PRODUCT_FAIL"

export const SHOP_PRODUCT_REQUEST = "SHOP_PRODUCT_REQUEST"
export const SHOP_PRODUCT_SUCCESS = "SHOP_PRODUCT_SUCCESS"
export const SHOP_PRODUCT_FAIL = "SHOP_PRODUCT_FAIL"

export const SEARCH_PRODUCT_REQUEST = "SEARCH_PRODUCT_REQUEST"
export const SEARCH_PRODUCT_SUCCESS = "SEARCH_PRODUCT_SUCCESS"
export const SEARCH_PRODUCT_FAIL = "SEARCH_PRODUCT_FAIL"
export const SEARCH_PRODUCT_CLEAR = "SEARCH_PRODUCT_CLEAR"

export const OPTIONS_REQUEST = "OPTIONS_REQUEST"
export const OPTIONS_SUCCESS = "OPTIONS_SUCCESS"
export const OPTIONS_FAIL = "OPTIONS_FAIL"

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST"
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS"
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL"

export const CREATE_COMMENT_REQUEST = "CREATE_COMMENT_REQUEST"
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS"
export const CREATE_COMMENT_FAIL = "CREATE_COMMENT_FAIL"
export const CREATE_COMMENT_CLEAR = "CREATE_COMMENT_CLEAR"

export const RELATED_PRODUCTS_REQUEST = "RELATED_PRODUCTS_REQUEST"
export const RELATED_PRODUCTS_SUCCESS = "RELATED_PRODUCTS_SUCCESS"
export const RELATED_PRODUCTS_FAIL = "RELATED_PRODUCTS_FAIL"

export const GET_ALL_PRODUCTS_REQUEST = "GET_ALL_PRODUCTS_REQUEST"
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS"
export const GET_ALL_PRODUCTS_FAIL = "GET_ALL_PRODUCTS_FAIL"
export const GET_ALL_PRODUCTS_CLEAR = "GET_ALL_PRODUCTS_CLEAR"

export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST"
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS"
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL"
export const CREATE_PRODUCT_CLEAR = "CREATE_PRODUCT_CLEAR"

export const GET_VENDOR_PRODUCT_REQUEST = "GET_VENDOR_PRODUCT_REQUEST"
export const GET_VENDOR_PRODUCT_SUCCESS = "GET_VENDOR_PRODUCT_SUCCESS"
export const GET_VENDOR_PRODUCT_FAIL = "GET_VENDOR_PRODUCT_FAIL"
export const GET_VENDOR_PRODUCT_CLEAR = "GET_VENDOR_PRODUCT_CLEAR"

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL"
export const UPDATE_PRODUCT_CLEAR = "UPDATE_PRODUCT_CLEAR"

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL"
export const DELETE_PRODUCT_CLEAR = "DELETE_PRODUCT_CLEAR"
